export default __webpack_public_path__ + "static/media/axim.66eab0c3.jpg";